import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

import { FileModel, fileSchema } from "./FileModel";

export type NurseNotice = {
  id: string;
  patientId: string;
  nurseFirstName?: string;
  nurseLastName?: string;
  nurseProfilePicture?: FileModel;
};

export const nurseNoticeSchema: Schema<NurseNotice> = cz.camelCaseObject({
  id: z.string(),
  patient_id: z.string(),
  nurse_first_name: cz.optional(z.string()),
  nurse_last_name: cz.optional(z.string()),
  nurse_profile_picture: cz.optional(fileSchema),
});

export type CreateNurseNotice = {
  patient_id: string;
};

export type DeleteNurseNotice = {
  patient_id: string;
  id: string;
};

export type MitigateNurseNotice = {
  patient_id: string;
  id: string;
};
